// Import icon images
import homeIcon from "../assets/icons/home.png";
import userIcon from "../assets/icons/user.png";
import dietIcon from "../assets/icons/diet.png";
import reportIcon from "../assets/icons/report.png";
import settingsIcon from "../assets/icons/settings.png";
import subscriptionIcon from "../assets/icons/subscription.png";
import dashboardIcon from "../assets/icons/dashboard.png";
import crmIcon from "../assets/icons/crm.png";
import inventoryIcon from "../assets/icons/inventory.png";
import rechargeIcon from "../assets/icons/recharge.png";
import userManagementIcon from "../assets/icons/user.png";
import storeIcon from "../assets/icons/store.png";
import adminIcon from "../assets/icons/admin.png";
import helpIcon from "../assets/icons/help.png";
import purchaseTopup from "../assets/icons/box.png";
import { Bot } from "lucide-react";
// ============================================
// ROLE DEFINITIONS
// ============================================
export const ROLES = {
  USER: "user",
  ADMIN: "admin",
  SUPER_ADMIN: "superadmin",
};

// ============================================
// MENU CONFIGURATION
// ============================================
export const getMenuConfig = () => {
  return {
    // ============================================
    // MAIN MENU ITEMS
    // ============================================
    main: [
      // ============================================
      // USER SPECIFIC MENUS - Simple User Interface
      // ============================================

      // Home - User Only
      {
        icon: homeIcon,
        name: "Home",
        subItems: [{ name: "Home", path: "/", pro: false }],
        roles: [ROLES.USER],
      },

      // Profile - User Only
      {
        icon: userIcon,
        name: "Profile",
        subItems: [
          { name: "My Profile", path: "/user/profile", pro: false },
          { name: "My Orders", path: "/user/orderslist", pro: false },
          { name: "Password Settings", path: "/user/password", pro: false },
        ],
        roles: [ROLES.USER],
      },

      // Diet - User Only
      {
        icon: dietIcon,
        name: "Diet",
        subItems: [
          {
            name: "Nutrition Centre",
            path: "/user/nutritioncentre",
            pro: false,
          },
          { name: "My Nutrition", path: "/user/my-nutrition", pro: false },
        ],
        roles: [ROLES.USER],
      },

      // Report - User Only
      {
        icon: reportIcon,
        name: "Report",
        subItems: [
          { name: "My Reports", path: "/user/reports", pro: false },
          {
            name: "Progress Report",
            path: "/user/reports/progress",
            pro: false,
          },
        ],
        roles: [ROLES.USER],
      },

      // Settings - User Only
      {
        icon: settingsIcon,
        name: "Settings",
        subItems: [
          {
            name: "Account Settings",
            path: "/user/settings/account",
            pro: false,
          },
          { name: "Privacy", path: "/user/settings/privacy", pro: false },
          {
            name: "Notifications",
            path: "/user/settings/notifications",
            pro: false,
          },
        ],
        roles: [ROLES.USER],
      },

      // Subscription - User Only
      {
        icon: subscriptionIcon,
        name: "Subscription",
        subItems: [
          { name: "My Subscriptions", path: "/user/subscriptions", pro: false },
          { name: "Plans", path: "/user/subscription/plans", pro: false },
        ],
        roles: [ROLES.USER],
      },

      // ============================================
      // ADMIN SPECIFIC MENUS
      // ============================================

      // Dashboard - Admin & Super Admin
      {
        icon: dashboardIcon,
        name: "Dashboard",
        subItems: [{ name: "Overview", path: "/", pro: false }],
        roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN],
      },

      // Sales - Admin & Super Admin
      {
        icon: storeIcon,
        name: "Sales",
        subItems: [
          { name: "Point of Sale", path: "/admin/sales", pro: false },
          { name: "Sales Report", path: "/admin/sales-report", pro: false },
        ],
        roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN],
      },

      // CRM - Admin & Super Admin
      {
        icon: crmIcon,
        name: "CRM",
        subItems: [
          { name: "CRM Dashboard", path: "/admin/crm", pro: false },
          { name: "Customers", path: "/admin/crm-users", pro: false },
        ],
        roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN],
      },


      // Inventory Management - Admin & Super Admin
      {
        icon: inventoryIcon,
        name: "Inventory",
        subItems: [
          { name: "Products", path: "/admin/products", pro: false },
          { name: "Add Product", path: "/admin/product/add", pro: false },
          { name: "Categories", path: "/admin/categories", pro: false },
          { name: "Product History", path: "/admin/product-history", pro: false },
        ],
        roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN],
      },
      {
        icon: userManagementIcon,
        name: "User Management",
        subItems: [
          { name: "Users List", path: "/userlist", pro: false },
          { name: "Create User", path: "/admin/add-user", pro: false },
          { name: "No Transaction List", path: "/admin/no-transaction-list", pro: false, new: true },
        ],
        roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN],
      },
      {
        icon: purchaseTopup,
        name: "Purchase Topup",
        subItems: [
          { name: "Purchase List", path: "/purchase-list", pro: false },
          { name: "Add Purchase", path: "/purchase-topup", pro: false },
        ],
        roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN],
      },

      // Recharge - Admin & Super Admin
      {
        icon: rechargeIcon,
        name: "Recharge",
        subItems: [
          { name: "Recharge", path: "/recharge", pro: false },
          { name: "Recharge List", path: "/admin/recharge-list", pro: false },
          { name: "Weekly Shake Setup", path: "/admin/weekly-shake-setup", pro: false },
          { name: "Consolidate Report", path: "/admin/consolidate-report", pro: false, new: true },
        ],
        roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN],
      },

      // Staff Management - Admin & Super Admin
      {
        icon: userManagementIcon,
        name: "Staff Management",
        subItems: [
          { name: "Manage Staff", path: "/admin/staff-management", pro: false },
        ],
        roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN],
      },

      // Expense Management - Admin & Super Admin
      {
        icon: rechargeIcon,
        name: "Expense Management",
        subItems: [
          { name: "Expenses & Advances", path: "/admin/expense-management", pro: false },
        ],
        roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN],
      },

      // Class Management - Admin & Super Admin
      {
        icon: userManagementIcon,
        name: "Class Management",
        subItems: [
          { name: "Online Classes", path: "/admin/class-management", pro: false },
        ],
        roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN],
      },

      // Inventory Dashboard - Admin & Super Admin
      // {
      //   icon: inventoryIcon,
      //   name: "Inventory Dashboard",
      //   subItems: [
      //     { name: "Dashboard", path: "/admin/inventory-dashboard", pro: false },
      //     { name: "Product Report", path: "/admin/product-report", pro: false },
      //   ],
      //   roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN],
      // },

      // AI Leads - Admin & Super Admin
      {
        icon: <Bot size={22} />,
        name: "AI Leads",
        subItems: [
          { name: "AI Leads", path: "/admin/ai-leads", pro: false, new: true },
        ],
        roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN],
      },

      // ============================================
      // SUPER ADMIN ONLY MENUSs
      // ============================================

      // Store Management - Super Admin Only
      {
        icon: storeIcon,
        name: "Store Management",
        subItems: [
          { name: "All Stores", path: "/superadmin/stores", pro: false },
          { name: "Add Store", path: "/superadmin/stores/add", pro: false },
          {
            name: "Store Analytics",
            path: "/superadmin/stores/analytics",
            pro: false,
          },
        ],
        roles: [ROLES.SUPER_ADMIN],
      },

      // Admin Management - Super Admin Only
      {
        icon: adminIcon,
        name: "Admin Management",
        subItems: [
          { name: "All Admins", path: "/superadmin/admins", pro: false },
          { name: "Add Admin", path: "/superadmin/admins/add", pro: false },
          {
            name: "Admin Activity",
            path: "/superadmin/admins/activity",
            pro: false,
          },
        ],
        roles: [ROLES.SUPER_ADMIN],
      },

      // System Settings - Super Admin Only
      {
        icon: settingsIcon,
        name: "System Settings",
        subItems: [
          {
            name: "Global Config",
            path: "/superadmin/settings/global",
            pro: false,
          },
          {
            name: "Roles & Permissions",
            path: "/superadmin/settings/roles",
            pro: false,
          },
          {
            name: "Security",
            path: "/superadmin/settings/security",
            pro: false,
          },
          {
            name: "Backup & Restore",
            path: "/superadmin/settings/backup",
            pro: false,
          },
          {
            name: "Activity Logs",
            path: "/superadmin/settings/logs",
            pro: false,
          },
        ],
        roles: [ROLES.SUPER_ADMIN],
      },
    ],

    // ============================================
    // OTHER MENU ITEMS
    // ============================================
    others: [
      // Help & Support - All Roles
      {
        icon: helpIcon,
        name: "Help & Support",
        subItems: [
          { name: "Documentation", path: "/help/docs", pro: false },
          { name: "Contact Support", path: "/help/support", pro: false },
          { name: "FAQs", path: "/help/faqs", pro: false },
        ],
        roles: [ROLES.USER, ROLES.ADMIN, ROLES.SUPER_ADMIN],
      },
    ],
  };
};

// ============================================
// ROLE-BASED MENU FILTERING
// ============================================
/**
 * Filters menu items based on user's role
 * @param {Array} menuItems - Array of menu items to filter
 * @param {string} userRole - Current user's role (user, admin, superadmin)
 * @returns {Array} Filtered menu items accessible to the user
 */
export const filterMenuByRole = (menuItems, userRole) => {
  if (!userRole) return [];

  return menuItems
    .filter((item) => {
      // If no roles specified, show to everyone
      if (!item.roles || item.roles.length === 0) {
        return true;
      }
      // Check if user's role is allowed
      return item.roles.includes(userRole);
    })
    .map((item) => {
      // Filter subItems based on roles
      if (item.subItems) {
        const filteredSubItems = item.subItems.filter((subItem) => {
          // If subItem has specific roles, check them
          if (subItem.roles && subItem.roles.length > 0) {
            return subItem.roles.includes(userRole);
          }
          // Otherwise, inherit from parent
          return true;
        });

        return {
          ...item,
          subItems: filteredSubItems,
        };
      }

      return item;
    })
    .filter((item) => {
      // Remove items with no subItems after filtering
      if (item.subItems && item.subItems.length === 0) {
        return false;
      }
      return true;
    });
};

// ============================================
// HELPER FUNCTIONS
// ============================================

/**
 * Get display name for a role
 * @param {string} role - Role identifier
 * @returns {string} Human-readable role name
 */
export const getRoleDisplayName = (role) => {
  const roleNames = {
    [ROLES.USER]: "User",
    [ROLES.ADMIN]: "Administrator",
    [ROLES.SUPER_ADMIN]: "Super Administrator",
  };
  return roleNames[role] || "User";
};

/**
 * Get menu items for a specific role
 * @param {string} userRole - User's role
 * @returns {Object} Object containing main and others menu items
 */
export const getMenuForRole = (userRole) => {
  const menuConfig = getMenuConfig();
  return {
    main: filterMenuByRole(menuConfig.main, userRole),
    others: filterMenuByRole(menuConfig.others, userRole),
  };
};

/**
 * Check if user has access to a specific path
 * @param {string} path - Route path to check
 * @param {string} userRole - User's role
 * @returns {boolean} True if user has access
 */
export const hasAccessToPath = (path, userRole) => {
  const menuConfig = getMenuConfig();
  const allMenuItems = [...menuConfig.main, ...menuConfig.others];

  for (const item of allMenuItems) {
    if (item.subItems) {
      for (const subItem of item.subItems) {
        if (subItem.path === path) {
          // Check if subItem has specific roles
          if (subItem.roles && subItem.roles.length > 0) {
            return subItem.roles.includes(userRole);
          }
          // Check parent item roles
          if (item.roles && item.roles.length > 0) {
            return item.roles.includes(userRole);
          }
          // If no roles specified, allow access
          return true;
        }
      }
    }
  }

  // Path not found in menu, allow access (public route)
  return true;
};
